var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.68 43.7229H34.0611L34.1621 43.3554L41.2268 17.6657H42.3V71.82H21.3029H20.8029V72.32V86V86.5H21.3029H76.0229H76.5229V86V72.32V71.82H76.0229H57.6314V10V9.5H57.1314H29.12H28.7428L28.6392 9.86264L19.5192 41.7826L19.5 41.85V41.92V43.2229V43.7229H20H33.68Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.c889e815f680ed0e3916e2f5da822cbf.svg";
export { ForwardRef as ReactComponent };